import type { ReactElement } from 'react'
import { ActionIcon, CopyButton, TextInput, Tooltip, type TextInputProps } from '@mantine/core'
import { type MaterialSymbolType } from '@front/model'
import { MaterialSymbolIcon } from './terros/icon/MaterialSymbolIcon'

type Props = Omit<TextInputProps, 'rightSection'>

export const CopyText = ({
  label,
  value,
  className,
  disabled,
  readOnly = true,
  ...inputProps
}: Props): ReactElement => {
  const copyValue = typeof value === 'string' ? value : ''
  return (
    <TextInput
      readOnly={readOnly}
      label={label}
      value={value}
      onClick={(e) => e.stopPropagation()}
      className={className}
      disabled={disabled}
      {...inputProps}
      rightSection={
        <CopyButton value={copyValue}>
          {({ copied, copy }) => {
            const icon: MaterialSymbolType = copied ? 'check' : 'content_copy'
            return (
              <Tooltip withArrow label={copied ? 'Copied' : 'Copy'} position='right'>
                <ActionIcon
                  aria-label={copied ? 'Copied' : 'Copy'}
                  color={copied ? 'teal' : 'gray'}
                  variant='subtle'
                  onClick={(e) => {
                    e.stopPropagation()
                    copy()
                  }}
                >
                  <MaterialSymbolIcon icon={icon} className='size-[70%]' />
                </ActionIcon>
              </Tooltip>
            )
          }}
        </CopyButton>
      }
    />
  )
}
